import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import {productTypeName} from "@/shared/model/productType";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import ProductPriceButtonComponent from "@/modules/ShoppingCart/components/ProductPriceButtonComponent.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import {computed} from "vue";
import {useAccountStore} from "@/stores/accountStore";
import ProductPrice from "@/shared/model/productPrice";



export default /*@__PURE__*/_defineComponent({
  __name: 'ProductPriceComponent',
  setup(__props) {


const _shoppingCartStore = useShoppingCartStore();
const {currentItem: _current} = storeToRefs(_shoppingCartStore);
const _accountStore = useAccountStore();


const _isBranch = computed(() => {
  return _accountStore.person && _accountStore.person.isBranch();
});

async function onSelectProductPrice(price: ProductPrice) {
  await _shoppingCartStore.setProductPrice(price);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(productTypeName)(_unref(_current).baseProductType)), 1)
        ]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogFlexRow, { style: {"justify-content":"left"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_current).productPrices, (productPrice) => {
                return _withDirectives((_openBlock(), _createBlock(ProductPriceButtonComponent, {
                  key: productPrice,
                  "product-price": productPrice,
                  "visible-price": !_isBranch.value,
                  onClick: ($event: any) => (onSelectProductPrice(productPrice))
                }, null, 8, ["product-price", "visible-price", "onClick"])), [
                  [_vShow, productPrice]
                ])
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})